const SUPPORT_EMAIL = "help@gazglobal.net";

interface MailtoOptions {
  to?: string;
  subject: string;
  body?: string;
}

export function openMailto({ to = SUPPORT_EMAIL, subject, body = "" }: MailtoOptions) {
  const parts = [`subject=${encodeURIComponent(subject)}`];
  if (body) parts.push(`body=${encodeURIComponent(body)}`);
  window.open(`mailto:${encodeURIComponent(to)}?${parts.join("&")}`, "_self");
}
